import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem('userToken');
    const tokenExpirationDate = localStorage.getItem('tokenExpirationDate');

    if (!token || !tokenExpirationDate) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    const isTokenExpired = new Date(tokenExpirationDate) < new Date();

    if (isTokenExpired) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('tokenExpirationDate');
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default PrivateRoute;
